import SearchInput from 'components/SearchInput/SearchInput';
import useBottomSheet from 'hooks/useCustomBottomSheet';
import React from 'react';
import { TextInputProps } from 'react-native';

type SearchInputProps = {
  testID: string;
  small?: boolean;
  clearable?: boolean;
  isTesting?: boolean;
  isSheet?: boolean;
  marginBottom?: number;
} & TextInputProps;

const SearchInputBottomSheet = ({
  testID,
  value,
  placeholder,
  small = true,
  clearable = false,
  isTesting = false,
  marginBottom,
  onChangeText,
  ...props
}: SearchInputProps) => {
  const { expand } = useBottomSheet();
  return (
    <SearchInput
      placeholder={placeholder}
      value={value}
      clearable={clearable}
      onChangeText={onChangeText}
      testID={testID}
      isTesting={isTesting}
      isSheet={true}
      onHandlePress={expand}
      onHandleFocus={expand}
      {...props}
    />
  );
};

export default SearchInputBottomSheet;
